{
  "(optional)": "(اختياري)",
  "(required)": "(مطلوب)"
}